export function sumOfArray(array: number[]): number {
    return Array.isArray(array) ? array.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0; // Return 0 for invalid input
}
